import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { Col, Row, UncontrolledTooltip } from "reactstrap";
import { IRootState } from "../../reducers";
import {
  getEntity as getApplicationDetails,
  getRelatedEntities as getApplications,
  reset as resetApplication,
} from "../../reducers/applicationsReducer";
import { IApplication } from "../../shared/model/application.model";
import { WorkDaySpanishTranslation } from "../../shared/model/enumerations/work-day.model";
import { Button } from 'react-bootstrap';
import { ITEMS_PER_PAGE_RELATED } from "../../shared/utils/pagination.constants";
import { SpinnerKonecta } from "../../shared/layout/spinner/Spinner";
import { ApplicationCardList } from "../home/application-card-list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faClock,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { ILocality } from "../../shared/model/locality.model";
import { ModalError } from "../../shared/dialog/modal-error";

interface IApplicationComponent
  extends StateProps,
  DispatchProps,
  RouteComponentProps<{ id: string }> { }

const ApplicationDetails = (props: IApplicationComponent) => {
  const { applicationDetail, applications, errorMessage } = props;
  const [loadingDetail, setLoadingDetail] = useState(true);

  const handleClose = () => {
    props.history.push("/" + props.location.search);
  };

  useEffect(() => {
    props.resetApplication();
    setLoadingDetail(true);
    props.getApplicationDetails(props.match.params.id);
    return () => {
      props.resetApplication();
    };
  }, [props.match.params.id]);

  useEffect(() => {
    if (applicationDetail?.localities) {
      const provinceIds = applicationDetail?.localities.map((currentValue) => {
        return currentValue?.province?.id || "";
      });
      const filter = `?idApplication=${applicationDetail.id
        }&provinces=${JSON.stringify(
          provinceIds
        )}&size=${ITEMS_PER_PAGE_RELATED}`;
      props.getApplications(filter);
    }
  }, [applicationDetail]);

  useEffect(() => {
    if (applicationDetail?.id) {
      setLoadingDetail(false);
    }
  }, [applicationDetail]);

  function capitalizeLocalityName(word: string | undefined) {
    if (!word) return '';

    let capitalizedWord = "";

    const segments = word.split(" ");


    segments.forEach(segment => capitalizedWord += segment[0].toUpperCase() + segment.slice(1).toLowerCase() + " ");

    return capitalizedWord;
  }

  return (
    <>
      {loadingDetail ? (
        <SpinnerKonecta />
      ) : (
        <>
          <div className="container-application-detail-box">
            <div className="application-extended-detail-box">
              <div className="application-extended-detail-title-box">
                <div className="application-extended-detail-title" id="applicationDetailName">
                  {applicationDetail.name}
                </div>
                <UncontrolledTooltip placement="bottom" target="applicationDetailName">
                  {applicationDetail.name}
                </UncontrolledTooltip>
              </div>
              <div className="application-extended-detail-article">
                <div className="row-header-article">
                  <FontAwesomeIcon icon={faClock} className="icon-province" />
                  {applicationDetail.workDay !== undefined
                    ? WorkDaySpanishTranslation[
                    applicationDetail.workDay as keyof typeof WorkDaySpanishTranslation
                    ]
                    : ""}
                </div>
                <div className="sales-article row-header-article">
                  <FontAwesomeIcon icon={faBriefcase} />
                  {applicationDetail.job?.name
                    ?.charAt(0)
                    .toUpperCase()}
                  {applicationDetail.job?.name
                    ?.slice(1)
                    .toLowerCase()}
                </div>
              </div>
              <div className="application-extended-detail-content">
                <div className="application-extended-detail-description">
                  <b>Detalle</b>
                  <br />
                  {applicationDetail.description}
                </div>
              </div>
              <div className="application-extended-detail-content-requirements">
                <div className="application-extended-detail-description">
                  <b>Requisitos</b>
                  <br />
                  {applicationDetail.minimumRequirements}
                </div>
              </div>
              <Row className="application-extended-detail-footer">
                <section className="container-locations">
                  {applicationDetail?.localities &&
                    applicationDetail.localities.map(
                      (locality: ILocality, index: number) => (
                        <div
                          className="application-extended-detail-footer-locations"
                          key={index}
                        >
                          <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            className="icon-province"
                          />
                          <span>{locality && capitalizeLocalityName(locality?.name)} ({locality?.province?.name})</span>
                        </div>
                      )
                    )}
                </section>
                <Col className="application-extended-detail-buttons" xs={12}>
                  <div className="go-back-button" onClick={handleClose}>
                    Volver
                  </div>
                  <Button
                    className="postulate-button"
                    onClick={() => {
                      props.history.push(
                        `/${applicationDetail.id}/postulate/${location.search}`
                      );
                    }}
                  >
                    Postularme
                  </Button>
                </Col>
              </Row>
            </div>
            <div className="container-applications-related">
              {applications?.length ? (
                <>
                  <div className="more-applications-title">
                    Más ofertas de trabajo
                  </div>
                  {applications.map((currentValue: IApplication) => (
                    <div
                      className="related-applications-cards"
                      key={currentValue.id}
                    >
                      <ApplicationCardList application={currentValue} />
                    </div>
                  ))}
                </>
              ) : null}
            </div>
          </div>
        </>
      )}
      {errorMessage && (
        <ModalError error={props.errorMessage} handleClose={handleClose} />
      )}
    </>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  applicationDetail: storeState.applicationReducer.entity,
  applications: storeState.applicationReducer.entities,
  errorMessage: storeState.applicationReducer.errorMessage,
  loading: storeState.applicationReducer.loading,
});

const mapDispatchToProps = {
  getApplications,
  getApplicationDetails,
  resetApplication,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationDetails);
